import { render, staticRenderFns } from "./EntryDialog.vue?vue&type=template&id=08851ede&scoped=true&"
import script from "./EntryDialog.vue?vue&type=script&lang=js&"
export * from "./EntryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08851ede",
  null
  
)

export default component.exports